import React from 'react';

export interface ActionButtonProps {
  onClick: () => void;
  children: React.ReactNode;
  variant?: 'primary' | 'danger' | 'neutral';
  style?: React.CSSProperties;
  disabled?: boolean;
}

export const ActionButton: React.FC<ActionButtonProps> = ({
  onClick,
  children,
  variant = 'primary',
  style,
  disabled,
}) => {
  const variantStyles = {
    primary: {
      backgroundColor: '#EEF1F4',
      color: '#1a1a1a',
      hover: {
        backgroundColor: '#E0E4E8',
      },
    },
    danger: {
      backgroundColor: '#FEE',
      color: '#CC0000',
      hover: {
        backgroundColor: '#FDD',
      },
    },
    neutral: {
      backgroundColor: '#EEF1F4',
      color: '#666',
      hover: {
        backgroundColor: '#E0E4E8',
      },
    },
  };

  const baseStyle = variantStyles[variant];

  return (
    <button
      onClick={onClick}
      disabled={disabled}
      style={{
        padding: '8px 16px',
        borderRadius: '8px',
        border: 'none',
        cursor: disabled ? 'not-allowed' : 'pointer',
        fontSize: '14px',
        fontWeight: 400,
        fontFamily: 'Inter, sans-serif',
        transition: 'all 0.2s ease',
        backgroundColor: baseStyle.backgroundColor,
        color: baseStyle.color,
        opacity: disabled ? 0.5 : 1,
        ...style,
      }}
      onMouseEnter={(e) => {
        if (!disabled) {
          e.currentTarget.style.backgroundColor = baseStyle.hover.backgroundColor;
        }
      }}
      onMouseLeave={(e) => {
        e.currentTarget.style.backgroundColor = baseStyle.backgroundColor;
      }}
    >
      {children}
    </button>
  );
};

